const ONE_DAY_MS = 24 * 60 * 60 * 1000;

function groupKoCardsByDocNo(koCards) {
	const grouped = {};

	for (const ko of koCards) {
		if (!ko.toDocNo) {
			continue;
		}

		if (!grouped[ko.toDocNo]) {
			grouped[ko.toDocNo] = {
				paidAmount: 0,
				lastKoDate: 0,
			};
		}

		grouped[ko.toDocNo].paidAmount += ko.amount + ko.gainLoss;
		grouped[ko.toDocNo].lastKoDate = Math.max(
			grouped[ko.toDocNo].lastKoDate,
			ko.koDate,
		);
	}

	return grouped;
}

function countLateInvoices(
	ivdnCards,
	koByDocNo,
	selectedAsOfDate,
) {
	let lateCount = 0;
	const openInvoiceDate = selectedAsOfDate + ONE_DAY_MS;

	for (const ivdn of ivdnCards) {
		const ko = koByDocNo[ivdn.docNo];
		const paidAmount = ko ? ko.paidAmount : 0;
		const outstanding = ivdn.amount - paidAmount;
		const settlementDate = outstanding >= 0.05
			? openInvoiceDate
			: ko
			? ko.lastKoDate
			: openInvoiceDate;

		if (settlementDate > ivdn.dueDate) {
			lateCount += 1;
		}
	}

	return lateCount;
}

module.exports = {
	countLateInvoices,
	groupKoCardsByDocNo,
};
